// websocket/turn-death-registry.ts — Janus Session A2 step 4c (2026-10-01): the turn-holder death reader, handed from turn-truth.ts (which owns
// the End Turn readers) to ability-truth.ts (whose ability / zone-entry verdicts may kill the turn holder) WITHOUT either importing the other —
// importing one truth module from another can close an ESM init cycle that kills the whole websocket bundle (2026-09-30). A leaf: types only.
import type { TurnDeathResult } from '../janus-engine/turns/end-turn.js';

type Row = Record<string, unknown>;
export type TurnDeathReader = (encounter: Row, members: ReadonlyMap<string, Row>, dyingId: string) => TurnDeathResult;
let reader: TurnDeathReader | null = null;
export function registerTurnDeathReader(next: TurnDeathReader): void { reader = next; }
/** null until turn-truth.ts has loaded: the ability lane then hands a turn-holder death back (the capability is absent). */
export function turnDeathReader(): TurnDeathReader | null { return reader; }
